import {
  type SchemaProperty,
  Mtds,
  buildSchemaPropertyList
} from 'prove-common'
import { useMemo } from 'react'

type SchemaPropertyListProps = {
  /** The raw PayloadSchema JSON string stored on ContractAnalysisType */
  schemaJson: string
}

export const SchemaPropertyList = ({ schemaJson }: SchemaPropertyListProps) => {
  const rows = useMemo<SchemaProperty[]>(
    () => buildSchemaPropertyList(schemaJson),
    [schemaJson]
  )

  if (rows.length === 0) {
    return <p>No schema properties are configured for this combination.</p>
  }

  return (
    <Mtds.Table data-size='sm'>
      <thead>
        <tr>
          <th>Property name</th>
          <th>Title</th>
          <th>Type</th>
          <th>Possible values</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.propertyKey}>
            <td>
              <code>{row.propertyKey}</code>
            </td>
            <td>{row.title ?? '-'}</td>
            <td>
              {row.type == null ? '-' : <Mtds.Muted>{row.type}</Mtds.Muted>}
            </td>
            <td>
              {row.enumValues != null && row.enumValues.length > 0 ? (
                <span className='inline-flex flex-wrap gap-x-1'>
                  {row.enumValues.map((v, j) => {
                    const enumValues = row.enumValues ?? []
                    return (
                      <span key={v}>
                        <code>{v}</code>
                        {j < enumValues.length - 1 ? ',' : ''}
                      </span>
                    )
                  })}
                </span>
              ) : (
                '-'
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </Mtds.Table>
  )
}
